import { render } from "./AboutQueueSection.vue?vue&type=template&id=6e45f1e2"
import script from "./AboutQueueSection.vue?vue&type=script&lang=js"
export * from "./AboutQueueSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__